module.exports = __webpack_public_path__ + "static/media/Time_white.3bb0b4f7.svg";